import { render, staticRenderFns } from "./VOverlay.vue?vue&type=template&id=83667a56&"
import script from "./VOverlay.vue?vue&type=script&lang=js&"
export * from "./VOverlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports